import Base from './Base';
import Trigger from './Trigger';

const Overlay = Base;
Overlay.Trigger = Trigger;
export default Overlay;
